import Eternl from '../../assets/icons/eternl-wallet.svg';
import Flint from '../../assets/icons/flint-wallet.svg';
import Gero from '../../assets/icons/gero-wallet.svg';
import Nami from '../../assets/icons/nami-wallet.svg';
import Yoroi from '../../assets/icons/yoroi-wallet.svg';
import Lace from '../../assets/icons/lace-wallet.svg';
import Typhon from '../../assets/icons/typhon-wallet.svg';
import Exodus from '../../assets/icons/exodus-wallet.svg';
export const walletItems = [
    {
        name: 'Nami',
        icon: Nami
    },
    {
        name: 'Eternl',
        icon: Eternl
    },
    {
        name: 'Flint',
        icon: Flint
    },
    {
        name: 'Yoroi',
        icon: Yoroi
    },
    {
        name: 'Typhon',
        icon: Typhon
    },
    {
        name: 'Lace',
        icon: Lace
    },
    {
        name: 'Exodus',
        icon: Exodus
    },
    {
        name: 'Gero',
        icon: Gero
    }
];
